"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@8base/utils");

var jwt_decode_1 = __importDefault(require("jwt-decode"));
/**
 * Creates instance of the web oauth client
 */


var WebOAuthClient =
/*#__PURE__*/
function () {
  function WebOAuthClient(options) {
    var storageOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, WebOAuthClient);

    utils_1.throwIfMissingRequiredParameters(['authorize'], utils_1.PACKAGES.WEB_AUTH0_AUTH_CLIENT, options);
    this.storageAPI = new utils_1.StorageAPI(storageOptions.storage || window.localStorage, storageOptions.storageKey || 'auth', storageOptions.initialState);
    this.options = options;
  }

  _createClass(WebOAuthClient, [{
    key: "setState",
    value: function setState(state) {
      this.storageAPI.setState(state);
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.storageAPI.getState();
    }
  }, {
    key: "purgeState",
    value: function purgeState() {
      this.storageAPI.purgeState();
    }
  }, {
    key: "checkIsAuthorized",
    value: function checkIsAuthorized() {
      var _this$getState = this.getState(),
          token = _this$getState.token;

      return token !== '' && token !== null && token !== undefined;
    }
  }, {
    key: "getTokenInfo",
    value: function getTokenInfo() {
      var _this$getState2 = this.getState(),
          token = _this$getState2.token;

      if (!token) {
        return undefined;
      }

      return jwt_decode_1.default(token) || undefined;
    }
  }, {
    key: "authorize",
    value: function authorize() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.options.authorize.apply(this, args);
    }
  }, {
    key: "logout",
    value: function logout() {
      if (typeof this.options.logout === 'function') {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return this.options.logout.apply(this, args);
      }
    }
  }]);

  return WebOAuthClient;
}();

exports.WebOAuthClient = WebOAuthClient;